import { Box, Text } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import { getContractStatus } from 'modules/contracts/components/ContractHistory/lib/getContractStatus'
import {
  ContractSchedule,
  getContractVersionSchedule,
} from 'modules/contracts/lib/graphqlContractVersionSchedule'

interface Props {
  employeeName: string
  selectedContractVersion: ContractVersionPageContractVersionFragment
  contractVersions: ContractVersionPageContractVersionFragment[]
}

const ContractData = ({ employeeName, selectedContractVersion, contractVersions }: Props) => {
  const contractVersionSchedule = getContractVersionSchedule(
    selectedContractVersion,
    contractVersions
  )
  const effectiveOnFormatted = i18nDateToString(
    stringToDate(selectedContractVersion.effectiveOn, 'backend'),
    'ui_abbreviated_month_year'
  )
  let tooltip
  let effectiveness
  switch (contractVersionSchedule) {
    case ContractSchedule.expired:
      effectiveness = i18n.t('contract_versions.header.effective_on')
      tooltip = i18n.t('contract_versions.header.effective_on_tooltip', {
        effectiveOn: effectiveOnFormatted,
      })
      break
    case ContractSchedule.ongoing:
      effectiveness = i18n.t('contract_versions.header.effective_since')
      tooltip = i18n.t('contract_versions.header.effective_since_tooltip', {
        effectiveOn: effectiveOnFormatted,
      })
      break
    case ContractSchedule.upcoming:
      effectiveness = i18n.t('contract_versions.header.effective_from')
      tooltip = i18n.t('contract_versions.header.effective_from_tooltip', {
        effectiveOn: effectiveOnFormatted,
      })
      break
  }

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 7 }} gap="s8">
      <Text size="500" weight="semibold" color="grey1000">
        {i18n.t('contract_versions.header.title', {
          name: employeeName,
          schedule: getContractStatus(contractVersionSchedule).toLocaleLowerCase(),
        })}
      </Text>
      <Box flexDirection="row" gap="s4">
        <Box flexDirection="row" gap="s2">
          <Text size="300" weight="normal" color="grey800">
            {effectiveness}{' '}
            <Text size="300" weight="medium" color="grey1000" inline>
              {effectiveOnFormatted}
            </Text>
          </Text>
        </Box>
        <ContractTooltip information={tooltip} icon="info-circle-line" color="grey800" />
      </Box>
    </Box>
  )
}

export default observer(ContractData)
